import React, { useState } from 'react'
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../../CONSTANTS";

function CreateOnvite({ show, onClose , user, createOnsite}) {
     
    const [step, setStep]                   = useState(1);
    const [formData, setFormData]           = useState({
        mainEventTitle: 'Wedding',
        mainEventDate: '',
        mainAddress: '',
        mainStart: '',
        mainEnd: '',
        receptionDate: '',
        receptionAddress: '',
        receptionStart: '',
        receptionEnd: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        spouseA: '',
        spouseB: '',
        inviteMessage: '',
    });

    if (!show) return null;
        
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const nextStep = () => setStep((prev) => prev + 1);
    const prevStep = () => setStep((prev) => prev - 1);

    const validateForm = () => {
        if (!formData.mainEventDate.trim()) {
          toast.warning("Main Date is required");
          setStep(1);
        return false;
        }

        if (!formData.mainAddress.trim()) {
          toast.warning("Main Address is required");
          setStep(1);
        return false;
        }

        if (!formData.mainStart.trim()) {
          toast.warning("Main Start Time is required");
          setStep(1);
        return false;
        }
        if (!formData.spouseA.trim()) {
          toast.warning("Spouse A Name is required");
          setStep(4);
        return false;
        }
        if (!formData.spouseB.trim()) {
          toast.warning("Spouse B Name is required");
          setStep(4);
        return false;
        }
        if (!formData.inviteMessage.trim()) {
          toast.warning("Event Invite Message is required");
          setStep(4);
        return false;
        }
        return true;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const postData = {
      ...formData,
      userId: user._id,
      userName: user.name,
      payOrder: createOnsite[0]
    };

    try {
        //console.log(postData);
      
      const resData = await axios.post(CONSTANTS.API_URL + 'annivites/create/v1/onvite', postData, {
                    headers: {
                      token: 'Bearer ' + user.accessToken,
                    },
                  }
                );      

      toast.success(resData.data.message);
      onClose();
      setTimeout(function () {
        ////redirect using url
        window.location.href = '/couple-event/' + resData.data.urlid;
      }, 5000)
    } catch (error) {
      toast.error("Failed to create Onvite");
      console.error(error);
    }
  };

  return (
     <div className="modal modal-dialogue-outer fade show d-block" tabIndex="-1" role="dialog">
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal-dialog modal-dialogue-a4 modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Onvite</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
             <form onSubmit={handleSubmit}>
                <div className="modal-body-content">
                    <div className="d-flex justify-content-center mb-4 gap-3">
                        {[1, 2, 3, 4].map((s) => (
                        <div
                            key={s}
                            className={
                            'rounded-circle border d-flex align-items-center justify-content-center fw-bold ' +
                            (step === s
                                ? 'bg-warning text-white'
                                : step > s
                                ? 'bg-main text-white'
                                : 'bg-light text-dark')
                            }
                            style={{ width: '40px', height: '40px' }}
                        >
                            {s}
                        </div>
                        ))}
                    </div>
                {step === 1 && (
                    <>
                    <div className="mb-3">
                        <label className="form-label">Main Type</label>
                        <input type="text" 
                          className="form-control" 
                          name="mainEvenTitle" 
                          value={formData.mainEventTitle} onChange={handleChange} 
                          />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Main Wedding</label>
                        <input 
                            type="date" 
                            className="form-control" 
                            name="mainEventDate" 
                            value={formData.mainEventDate} 
                            onChange={handleChange} 
                            min={new Date().toISOString().split('T')[0]}
                            />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Address (required)</label>
                        <input type="text" className="form-control" name="mainAddress" value={formData.mainAddress} onChange={handleChange} required />
                    </div>

                    <div className="row">
                        <div className="col">
                            <label className="form-label">Start Time (required)</label>
                            <input type="time" className="form-control" name="mainStart" value={formData.mainStart} onChange={handleChange} required />
                        </div>
                        <div className="col">
                            <label className="form-label">End Time</label>
                            <input type="time" className="form-control" name="mainEnd" value={formData.mainEnd} onChange={handleChange} />
                        </div>
                    </div>
                    </>
                )}

                {step === 2 && (
                    <>
                    <div className="mb-3">
                      <label className="form-label">Reception Date</label>
                      <input 
                        type="date" 
                        className="form-control" 
                        name="receptionDate" 
                        value={formData.receptionDate} 
                        onChange={handleChange} 
                        min={new Date().toISOString().split('T')[0]}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Reception Address</label>
                        <input type="text" className="form-control" name="receptionAddress" value={formData.receptionAddress} onChange={handleChange} />
                    </div>

                    <div className="row">
                        <div className="col">
                        <label className="form-label">Start Time</label>
                        <input type="time" className="form-control" name="receptionStart" value={formData.receptionStart} onChange={handleChange} />
                        </div>
                        <div className="col">
                        <label className="form-label">End Time</label>
                        <input type="time" className="form-control" name="receptionEnd" value={formData.receptionEnd} onChange={handleChange} />
                        </div>
                    </div>
                    </>
                )}

                {step === 3 && (
                    <>
                    <div className="mb-3">
                        <label className="form-label">Contact Name</label>
                        <input type="text" className="form-control" name="contactName" value={formData.contactName} onChange={handleChange} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Contact Email</label>
                        <input type="email" className="form-control" name="contactEmail" value={formData.contactEmail} onChange={handleChange} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Contact Phone</label>
                        <input type="tel" className="form-control" name="contactPhone" value={formData.contactPhone} onChange={handleChange} />
                    </div>
                    </>
                )}

                {step === 4 && (
                    <>
                    <div className="mb-3">
                        <label className="form-label">Spouse A Name (required)</label>
                        <input type="text" className="form-control" name="spouseA" value={formData.spouseA} onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Spouse B Name (required)</label>
                        <input type="text" className="form-control" name="spouseB" value={formData.spouseB} onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Event Invite Message (required)</label>
                        {/* For WYSIWYG, you can replace this with a rich editor like react-quill */}
                        <textarea className="form-control" name="inviteMessage" rows="4" value={formData.inviteMessage} onChange={handleChange} required />
                    </div>
                    </>
                )}
                </div>

            <div className="modal-footer">
              {step > 1 && (
                <button type="button" className="btn btn-main" onClick={prevStep}>
                  Back
                </button>
              )}
              {step < 4 ? (
                <button type="button" className="btn btn-main" onClick={nextStep}>
                  Next
                </button>
              ) : (
                <button type="submit" className="btn btn-success">
                  Submit
                </button>
              )}
            </div>
          </form>


          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateOnvite